import confetti from 'canvas-confetti';

export const triggerConfetti = () => {
  // Fire confetti from both sides
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
    zIndex: 9999,
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
    origin: { x: 0.2 },
  });

  fire(0.2, {
    spread: 60,
    origin: { x: 0.4 },
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
    origin: { x: 0.6 },
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
    origin: { x: 0.8 },
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
    origin: { x: 0.5 },
  });
};

export const triggerSuccessConfetti = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#22c55e', '#16a34a', '#15803d'],
    zIndex: 9999,
  });
};

export default { triggerConfetti, triggerSuccessConfetti };
